module.exports = __webpack_public_path__ + "static/204ad9728c16b6cfccb4230e2e12d05c6a898fc24cef89fa923184ca2f681262-d479e36f4fc732d2b888ee7f1623737e.png";